export default __webpack_public_path__ + "static/Support-and-resources-together-26e739c5aab174a2574bd3d669662068.jpg";